import ClassroomLoading from './ClassroomLoading';

export default ClassroomLoading;
